import { I18nStrings, LanguageString, LanguageStrings } from '@crimsontide/core/client/language/interfaces';
import { flatten } from '../../../../TsUtils/utils';

export const LanguageService = (() => {
  const languageStrings: LanguageStrings = {};
  const setLanguageNestedStrings = (strings: I18nStrings, merge: boolean = true): void => {
    return setFlatLanguageStrings(flatten(strings), merge);
  };

  const setLanguageStrings = (strings: LanguageString[], merge: boolean = true): void => {
    return setFlatLanguageStrings(
      strings.reduce(
        (s, o) => {
          s[o.resourceName] = o.resourceValue;

          return s;
        },
        {} as LanguageStrings,
      ),
      merge,
    );
  };

  const setFlatLanguageStrings = (strings: LanguageStrings, merge: boolean = true): void => {
    if (merge) {
      Object.assign(languageStrings, strings);
    }
    else {
      for (const key in languageStrings) {
        if (languageStrings.hasOwnProperty(key)) {
          delete languageStrings[ key ];
        }
      }
      Object.assign(languageStrings, strings);
    }
  };

  const translate = (key: string, param?: { [key: string]: string | number | boolean}): string => {
    let translation = languageStrings[key];

    if (param && typeof param === 'object') {
      const paramKeys = Object.keys(param);

      paramKeys.forEach((p) => {
        translation = translation.replace(`{{${p}}}`, param[ p ].toString());
      });
    }

    return translation || key;
  };

  return {
    setLanguageNestedStrings,
    setLanguageStrings,
    setFlatLanguageStrings,
    translate,
  };
})();
